import { PagedMultiSelectField, laravelServiceSelectFetchConfig } from "@dgs/core";
import { FC } from "react";
import { regionService } from "../api/regionService";

const fetchConfig = laravelServiceSelectFetchConfig(regionService);

interface Props {
	name: string;
	label: string;
	required?: boolean;
}

export const RegionMultiSelectField: FC<Props> = (props) => {
	return <PagedMultiSelectField {...props} fetchConfig={fetchConfig} />;
};
